import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { secondsToTimeString } from "@/react/helpers/dateTimeHelpers";

interface DurationProps {
  durationInSeconds: number;
}

export const Duration = ({ durationInSeconds }: DurationProps) => (
  <div>
    <Typography.LabelSm weight="medium">
      {t("live_streams.dashboard.details.duration")}
    </Typography.LabelSm>
    <Typography.BodySm>
      {secondsToTimeString(durationInSeconds)}
    </Typography.BodySm>
  </div>
);
